"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[501],{

/***/ 5559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MessagesTable; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./src/components/ScannerLink.tsx
var ScannerLink = __webpack_require__(25963);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/fromUnixTime/index.js
var fromUnixTime = __webpack_require__(42227);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistanceToNowStrict/index.js + 1 modules
var formatDistanceToNowStrict = __webpack_require__(91713);
// EXTERNAL MODULE: ./src/hooks/sourceChain.ts
var hooks_sourceChain = __webpack_require__(10024);
// EXTERNAL MODULE: ./src/lib/chainIdMap.ts
var chainIdMap = __webpack_require__(1774);
// EXTERNAL MODULE: ./src/lib/chains.ts
var chains = __webpack_require__(90380);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(47516);
;// CONCATENATED MODULE: ./src/components/messagesTable/MessageRow.tsx










const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red"
};
function LoadingText(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "start"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiLoaderAlt */.sOR, {
                size: "20px",
                className: "mb-1 animate-spin"
            }),
            "\xa0 ",
            children
        ]
    });
}
function MessageRow(param) {
    let { messageNonce , sourceTransaction , targetTransaction , latestHeadUpdates , lastFinalizedBlock  } = param;
    var ref;
    const router = (0,next_router.useRouter)();
    const sourceChain = (0,react.useContext)(hooks_sourceChain/* SourceChainContext */.N);
    const { messageReceiverChainID , messageSender , messageReceiver  } = sourceTransaction || {};
    const sourceTimestamp = (0,react.useMemo)(()=>{
        return (0,fromUnixTime/* default */.Z)(sourceTransaction === null || sourceTransaction === void 0 ? void 0 : sourceTransaction.blockTimestamp);
    }, [
        sourceTransaction
    ]);
    const targetTimestamp = (0,react.useMemo)(()=>{
        return (0,fromUnixTime/* default */.Z)(targetTransaction === null || targetTransaction === void 0 ? void 0 : targetTransaction.blockTimestamp);
    }, [
        targetTransaction
    ]);
    const targetChain = chainIdMap/* default.get */.Z.get(parseInt(messageReceiverChainID));
    const targetChainName = targetChain !== undefined ? (ref = chains/* default */.ZP[targetChain]) === null || ref === void 0 ? void 0 : ref.name : "Unknown (".concat(messageReceiverChainID, ")");
    const missingTargetTxnStatus = (0,react.useMemo)(()=>{
        if (targetTransaction === null) {
            if (!chains/* DESTINATION_CHAINS */.Bc[sourceChain].includes(targetChain)) {
                return "Unindexed chain";
            }
            if (latestHeadUpdates.has(targetChain)) {
                if (latestHeadUpdates.get(targetChain) < sourceTransaction.blockNumber) {
                    if (lastFinalizedBlock !== null && lastFinalizedBlock < (sourceTransaction === null || sourceTransaction === void 0 ? void 0 : sourceTransaction.blockNumber)) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText, {
                            children: "Waiting for block to finalize"
                        });
                    } else {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText, {
                            children: "Waiting for proof of consensus"
                        });
                    }
                } else {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText, {
                        children: "Waiting for relayer"
                    });
                }
            } else {
                return "Transaction not found";
            }
        } else {
            return null;
        }
    }, [
        targetTransaction,
        lastFinalizedBlock,
        latestHeadUpdates,
        sourceTransaction,
        sourceChain,
        targetChain
    ]);
    if (sourceTransaction === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "py-4 px-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/nonce/".concat(messageNonce),
                        className: "text-succinct-neon",
                        children: messageNonce
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    colSpan: 7,
                    className: "py-4 px-3",
                    children: "Missing from subgraph"
                })
            ]
        });
    }
    const onClickRow = (e)=>{
        if (e.target instanceof HTMLAnchorElement) {
            return;
        }
        router.push("/nonce/".concat(messageNonce));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        className: "min-w-full cursor-pointer bg-succinct-teal-5 text-white hover:bg-succinct-teal-10",
        onClick: onClickRow,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "px-3 font-mono text-succinct-teal",
                children: messageNonce
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "py-4 px-3",
                children: targetChainName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "py-4 px-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScannerLink/* default */.Z, {
                    value: sourceTransaction === null || sourceTransaction === void 0 ? void 0 : sourceTransaction.transactionOrigin,
                    chain: sourceChain,
                    type: ScannerLink/* ScannerType.Address */.w.Address,
                    shorten: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "py-4 px-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScannerLink/* default */.Z, {
                    value: messageSender,
                    chain: sourceChain,
                    type: ScannerLink/* ScannerType.Address */.w.Address,
                    shorten: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "py-4 px-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScannerLink/* default */.Z, {
                    value: messageReceiver,
                    chain: targetChain || "mainnet",
                    type: ScannerLink/* ScannerType.Address */.w.Address,
                    shorten: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "py-4 px-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScannerLink/* default */.Z, {
                    value: sourceTransaction.transactionHash,
                    chain: sourceChain,
                    type: ScannerLink/* ScannerType.Tx */.w.Tx,
                    shorten: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "py-4 px-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    title: sourceTimestamp.toLocaleString(),
                    children: (0,formatDistanceToNowStrict/* default */.Z)(sourceTimestamp, {
                        addSuffix: true
                    })
                })
            }),
            targetTransaction === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: "py-4 px-3",
                colSpan: 2,
                children: missingTargetTxnStatus
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "py-4 px-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScannerLink/* default */.Z, {
                            value: targetTransaction.transactionHash,
                            chain: chainIdMap/* default.get */.Z.get(parseInt(messageReceiverChainID)),
                            type: ScannerLink/* ScannerType.Tx */.w.Tx,
                            shorten: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "py-4 px-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            title: targetTimestamp.toLocaleString(),
                            children: (0,formatDistanceToNowStrict/* default */.Z)(targetTimestamp, {
                                addSuffix: true
                            })
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/messagesTable/MessagesTable.tsx



function MessagesTable(param) {
    let { rows , loading , latestHeadUpdates , lastFinalizedBlock  } = param;
    var ref;
    const latestMsg = rows && rows.length > 0 && rows[0] && ((ref = rows[0][0]) === null || ref === void 0 ? void 0 : ref.messageNonce) || undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "box-border w-full overflow-x-auto p-[1px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-fit min-w-full overflow-hidden rounded-md sm:-mx-6 md:mx-0 md:rounded-lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: "w-full min-w-full table-fixed border-separate border-spacing-y-4 whitespace-nowrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        className: "rounded-lg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            className: "ibm-plex-regular border-b text-left text-sm",
                            style: {
                                color: "#C3DFE0",
                                opacity: "40%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "w-[75px] py-3 px-3",
                                    children: "NONCE"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "w-[130px] py-3 px-3",
                                    children: "DESTINATION"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "w-[130px] py-3 px-3",
                                    children: "TXN ORIGIN"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "w-[130px] py-3 px-3",
                                    children: "MSG SENDER"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "w-[130px] py-3 px-3",
                                    children: "MSG RECEIVER"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "w-[270px] py-3 px-3",
                                    colSpan: 2,
                                    children: "SOURCE TXN"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    className: "w-[275px] py-3 px-3",
                                    colSpan: 2,
                                    children: "TARGET TXN"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        className: "divide-y divide-gray-300",
                        children: [
                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    colSpan: 8,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex h-40 items-center justify-center text-white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                            size: "60px",
                                            color: "inherit"
                                        })
                                    })
                                })
                            }),
                            !loading && rows.map((param, idx)=>{
                                let [sentMessage, executedMessage] = param;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(MessageRow, {
                                    messageNonce: (sentMessage === null || sentMessage === void 0 ? void 0 : sentMessage.messageNonce) || latestMsg - idx,
                                    sourceTransaction: sentMessage,
                                    targetTransaction: executedMessage,
                                    latestHeadUpdates: latestHeadUpdates,
                                    lastFinalizedBlock: lastFinalizedBlock
                                }, (sentMessage === null || sentMessage === void 0 ? void 0 : sentMessage.messageNonce) || latestMsg - idx);
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 29521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RM": function() { return /* binding */ useSentMessagesQuery; },
/* harmony export */   "Tk": function() { return /* binding */ useExecutedMessagesQuery; },
/* harmony export */   "WQ": function() { return /* binding */ useLastFinalizedBlock; },
/* harmony export */   "c_": function() { return /* binding */ useLatestHeadUpdates; }
/* harmony export */ });
/* unused harmony export useLastFinalizedSlot */
/* harmony import */ var _lib_graphSDK__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30921);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6154);
/* harmony import */ var lib_chains__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90380);
/* harmony import */ var lib_subgraphs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57448);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var use_immer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90057);






function convertFiltersToGraphQL(filters, destinationChainCount) {
    let whereClause = {};
    if (filters.chain !== null && filters.chain.length < destinationChainCount) {
        whereClause.messageReceiverChainID_in = filters.chain.map((c)=>lib_chains__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP[c].chainId);
    }
    if (filters.origin !== null && filters.origin !== "") {
        whereClause.transactionOrigin = filters.origin;
    }
    if (filters.source !== null && filters.source !== "") {
        whereClause.messageSender = filters.source;
    }
    if (filters.target !== null && filters.target !== "") {
        whereClause.messageReceiver = filters.target;
    }
    if (filters.startDate !== null) {
        whereClause.blockTimestamp_gte = filters.startDate.getTime() / 1000;
    }
    if (filters.endDate !== null) {
        whereClause.blockTimestamp_lte = filters.endDate.getTime() / 1000;
    }
    return whereClause;
}
function filtersAreDefault(filters, destinationChainCount) {
    return (filters.chain === null || filters.chain.length === destinationChainCount) && (filters.origin === null || filters.origin === "") && (filters.source === null || filters.source === "") && (filters.target === null || filters.target === "") && filters.startDate === null && filters.endDate === null;
}
function useSentMessagesQuery(page, count, filters, sourceChain) {
    const [results, setResults] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const destinationChainCount = lib_chains__WEBPACK_IMPORTED_MODULE_1__/* .DESTINATION_CHAINS */ .Bc[sourceChain].length;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        async function fetchMessages() {
            setLoading(true);
            const where = convertFiltersToGraphQL(filters, destinationChainCount);
            const res = await _lib_graphSDK__WEBPACK_IMPORTED_MODULE_0__/* .graphSDK.GetSentMessages */ .P.GetSentMessages({
                where,
                skip: (page - 1) * count,
                count: count
            }, {
                subgraphName: (0,lib_subgraphs__WEBPACK_IMPORTED_MODULE_2__/* .getSubgraphName */ .U)(sourceChain)
            });
            const sentMessages = res.sentMessages;
            if (sentMessages.length === 0) {
                setLoading(false);
                setResults([]);
            }
            if (filtersAreDefault(filters, destinationChainCount)) {
                var ref;
                // In the case that the subgraph errored (due to bug in indexer code) and rows are missing,
                // fill those rows with null so that the results array is contiguous by nonce
                // We can only do this when there are no filters (and we expect a contiguous result)
                let filledMessages = [];
                let sentMessageIndex = 0;
                let maxNonce = parseInt((ref = sentMessages[0]) === null || ref === void 0 ? void 0 : ref.messageNonce);
                for(let filledMessageIndex = 0; filledMessageIndex < count && maxNonce - filledMessageIndex > 0; ++filledMessageIndex){
                    var ref1;
                    if (sentMessages[sentMessageIndex] !== undefined && parseInt((ref1 = sentMessages[sentMessageIndex]) === null || ref1 === void 0 ? void 0 : ref1.messageNonce) === maxNonce - filledMessageIndex) {
                        filledMessages.push(sentMessages[sentMessageIndex++]);
                    } else {
                        filledMessages.push(null);
                    }
                }
                setResults(filledMessages);
            } else {
                setResults(sentMessages);
            }
            setLoading(false);
        }
        fetchMessages();
    }, [
        page,
        count,
        filters,
        sourceChain
    ]);
    return [
        results,
        loading
    ];
}
function useExecutedMessagesQuery(sentMessages, sourceChain) {
    const [results, setResults] = (0,use_immer__WEBPACK_IMPORTED_MODULE_4__/* .useImmer */ .x)(new Map());
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        async function fetchMessages(destinationChain) {
            setLoading(true);
            const where = {
                messageSenderChainID: lib_chains__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP[sourceChain].chainId,
                messageNonce_in: sentMessages.filter((msg)=>msg !== undefined && msg !== null).map((msg)=>{
                    return msg === null || msg === void 0 ? void 0 : msg.messageNonce;
                })
            };
            const res = await _lib_graphSDK__WEBPACK_IMPORTED_MODULE_0__/* .graphSDK.GetExecutedMessages */ .P.GetExecutedMessages({
                where,
                skip: 0,
                count: sentMessages.length
            }, {
                subgraphName: (0,lib_subgraphs__WEBPACK_IMPORTED_MODULE_2__/* .getSubgraphName */ .U)(destinationChain)
            });
            const executedMessages = res.executedMessages;
            setResults((map)=>{
                executedMessages.map((msg)=>map.set(msg.messageNonce, msg));
            });
        }
        async function fetchAllMessages() {
            setLoading(true);
            await Promise.all(lib_chains__WEBPACK_IMPORTED_MODULE_1__/* .DESTINATION_CHAINS */ .Bc[sourceChain].map((c)=>fetchMessages(c)) || []);
            setLoading(false);
        }
        setResults((map)=>map.clear());
        if (sentMessages.length > 0) fetchAllMessages();
    }, [
        sentMessages,
        sourceChain
    ]);
    return [
        results,
        loading
    ];
}
// Gets the latest head updates on each destination chain, then calculates the corresponding block number from slot number
function useLatestHeadUpdates(sourceChain) {
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [results, setResults] = (0,use_immer__WEBPACK_IMPORTED_MODULE_4__/* .useImmer */ .x)(new Map());
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        async function fetchHeadUpdates() {
            setLoading(true);
            setResults(new Map());
            const promises = lib_chains__WEBPACK_IMPORTED_MODULE_1__/* .DESTINATION_CHAINS */ .Bc[sourceChain].map(async (destinationChain)=>{
                var ref;
                const res = await _lib_graphSDK__WEBPACK_IMPORTED_MODULE_0__/* .graphSDK.GetRecentHeadUpdates */ .P.GetRecentHeadUpdates({
                    sourceChain: lib_chains__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP[sourceChain].chainId,
                    first: 1,
                    skip: 0
                }, {
                    subgraphName: (0,lib_subgraphs__WEBPACK_IMPORTED_MODULE_2__/* .getSubgraphName */ .U)(destinationChain)
                });
                // TODO: this fails when no head updates have been sent yet
                return parseInt(((ref = res.headUpdates[0]) === null || ref === void 0 ? void 0 : ref.slot) || "0");
            });
            const slotNumbers = await Promise.all(promises);
            const blockNumberRes = await axios__WEBPACK_IMPORTED_MODULE_5__/* ["default"].post */ .Z.post("/api/getBlockNumbers", {
                slots: slotNumbers,
                sourceChain: sourceChain
            });
            setResults((map)=>{
                lib_chains__WEBPACK_IMPORTED_MODULE_1__/* .DESTINATION_CHAINS */ .Bc[sourceChain].map((chain, idx)=>map.set(chain, blockNumberRes.data[idx]));
            });
            setLoading(false);
        }
        fetchHeadUpdates();
    }, [
        sourceChain
    ]);
    return [
        results,
        loading
    ];
}
function useLastFinalizedSlot(sourceChain) {
    const [slot, setSlot] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        async function fetchNodeData() {
            setSlot(null);
            const res = await fetch(lib_chains__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP[sourceChain].nodeUrl + "eth/v1/beacon/headers/finalized");
            const json = await res.json();
            setSlot(parseInt(json.data.header.message.slot));
        }
        fetchNodeData();
    }, [
        sourceChain
    ]);
    return slot;
}
function useLastFinalizedBlock(sourceChain) {
    const slot = useLastFinalizedSlot(sourceChain);
    const [block, setBlock] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        async function fetchBlockNumber() {
            const blockNumberRes = await axios__WEBPACK_IMPORTED_MODULE_5__/* ["default"].post */ .Z.post("/api/getBlockNumbers", {
                slots: [
                    slot
                ],
                sourceChain: sourceChain
            });
            setBlock(blockNumberRes.data[0]);
        }
        fetchBlockNumber();
    }, [
        sourceChain,
        slot
    ]);
    return block;
}


/***/ }),

/***/ 89780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


const NoSSR = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(async ()=>NoSSR, {
    ssr: false
}));


/***/ }),

/***/ 1774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lib_chains__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90380);

const chainIdMap = new Map();
for (let key of Object.keys(lib_chains__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)){
    var ref;
    chainIdMap.set((ref = lib_chains__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP[key]) === null || ref === void 0 ? void 0 : ref.chainId, key);
}
/* harmony default export */ __webpack_exports__["Z"] = (chainIdMap);


/***/ }),

/***/ 20982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ DefaultMessageTableFilters; }
/* harmony export */ });
const DefaultMessageTableFilters = {
    chain: null,
    origin: null,
    source: null,
    target: null,
    startDate: null,
    endDate: null
};


/***/ })

}]);